export default __webpack_public_path__ + "static/media/sport.c36697a7.svg";